import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { mergeMap, map, catchError, finalize, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';

import { createUserErrorAction } from '../actions/users.actions';
import { NotificationService } from '../../shared/services/notification.service';
import { PremiitError } from '../../utils/premiit-error';
import { ResponseData } from '../../utils/response';
import { Role } from '../../pages/roles/role';
import { RoleService } from '../../pages/roles/role.service';
import { RoleView } from '../../pages/roles/role-view';
import * as rolesActions from '../actions/roles.action';

@Injectable()
export class RolesEffects {
  constructor(private actions$: Actions, private roleService: RoleService, private notify: NotificationService,
    private router: Router) {}

  public getRolesEffect = createEffect(
    () => this.actions$.pipe(
      ofType(rolesActions.getRolesAction),
      mergeMap(() => {
        return this.roleService.findAllRoles()
          .pipe(
            map((response: ResponseData<RoleView[]>) => {
              const roles: RoleView[] = response.data;
              return rolesActions.getRolesSuccessAction({ roles });
            }),
            catchError(( error: PremiitError) => {
              return of(rolesActions.getRolesErrorAction({ error }));
            })
          );
      })
    )
  );

  public createRoleEffect = createEffect(
    () => this.actions$.pipe(
      ofType(rolesActions.createRoleAction),
      mergeMap((action) => {
        return this.roleService.createRole(action.role)
          .pipe(
            map((createdRole: RoleView) => {
              return rolesActions.createRoleSuccessAction({ role: createdRole });
            }),
            tap(() => {
              this.notify.success('Role creado con éxito');
              this.router.navigate(['roles']);
            }),
            catchError( error => {
              this.notify.customError(error);
              return of(rolesActions.createRoleErrorAction({ error }));
            })
          );
      })
    )
  );

  public deleteRoleEffect = createEffect(
    () => this.actions$.pipe(
      ofType(rolesActions.deleteRoleAction),
      mergeMap((action) => {
        return this.roleService.deleteRole(action.role)
          .pipe(
            map((response: ResponseData<Role>) => {
              const deletedRole: Role = response.data;
              this.notify.success('rol eliminado con éxito');
              return rolesActions.deleteRoleSuccessfullyAction({ role: deletedRole });
            }),
            catchError( error => {
              this.notify.customError(error);
              return of(rolesActions.deleteRoleError({ error }));
            })
          );
      })
    )
  );

  public updateRoleEffect = createEffect(
    () => this.actions$.pipe(
      ofType(rolesActions.updateRoleAction),
      mergeMap((action) => {
        return this.roleService.updateRole(action.role)
          .pipe(
            map((response: ResponseData<RoleView>) => {
              const updatedRole: RoleView = response.data;
              this.notify.success('El rol se actualizo con éxito');
              return rolesActions.updateRoleSuccessAction({ role: updatedRole });
            }),
            catchError((error: PremiitError) => {
              this.notify.customError(error);
              return of(rolesActions.updateRoleErrorAction({ error }));
            })
          );
      })
    )
  );
}
